import { request, url as urlModule } from '@tencent/ppd-base-libs';

/// app/promotion/gov_coupons/mer_coupon_exec_act.cgi

/**
 * 获取券分类列表信息
 * @param spid 商户ID
 * @param couponId 券ID，如果指定了券，则领取该单张券
 * @returns
 */
export async function batchGetCoupons(spid: string, couponId?: string): Promise<{
  /** 券ID */
  couponId: string,
  /** 券领取状态 */
  recvState: number,
  /** 用户券id */
  userScid: string,
}[]> {
  const isDebugger = urlModule.getUrlParam('wecoupon_debugger') === '1';
  const debugOptions = isDebugger ? { is_debug: 1 } : {};
  const url = '/app/promotion/we_coupon/we_coupon_batch_get.cgi';
  const { coupon_array: couponArray } = await request.get(url, {
    params: { spid, coupon_id: couponId, ...debugOptions },
  });
  return couponArray.map(item => ({
    couponId: item.coupon_id,
    recvState: item.recv_state,
    userScid: item.user_scid,
  }));
}
